import { importCsvApi, laborProtectionApi } from "@/getinfo-api";
import { ImportTypes } from "@/getinfo-api/imports2";
import { Import } from "@/api-v2/import-export/models/import";
import { WorkerImport } from "@/api-v2/labor-protection/models/worker-import";

export class ImportDetailInfo {
  static async getDetailImport(
    type: ImportTypes,
    id: string
  ): Promise<WorkerImport | Import | undefined> {
    try {
      if (type === ImportTypes.UserCSV) {
        let { data } = await importCsvApi.ImportApi.getImport(id);
        return data;
      }

      if (type === ImportTypes.ContractorCSV) {
        let { data } = await importCsvApi.ImportApi.getImport(id);
        return data;
      }

      if (type === ImportTypes.CourseV1JSON) {
        let { data } = await importCsvApi.ImportApi.getImport(id);
        return data;
      }

      if (type === ImportTypes.StudentCSV) {
        let { data } = await importCsvApi.ImportApi.getImport(id);
        return data;
      }

      if (type === ImportTypes.LaborProtectionWorkerImport) {
        let { data } = await laborProtectionApi.Worker.getImportWorker(id);
        return data;
      }
    } catch (e) {
      console.warn(e);
    }
  }
}
